import React from 'react';

import styled from '@emotion/styled';

import Card from '../../../components/Cards/Card';
import BagCancelIcon from '../../../components/Icons/BagCancelIcon';
import BagCheckIcon from '../../../components/Icons/BagCheckIcon';
import { useAppSelector } from '../../../redux/store';

const UserOverview = () => {
  const { dashboardStatsData } = useAppSelector((state) => state.dashboardData);

  return (
    <Container>
      {/* <CardTitle>OVERVIEW</CardTitle> */}
      <CardContainerWrapper>
        {/* Card 1 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <BagCheckIcon /> No of Active Companies
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.activePartners ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>

        {/* Card 2 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <BagCancelIcon /> No of Deleted Companies
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.deletedPartners ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>
      </CardContainerWrapper>
    </Container>
  );
};

export default UserOverview;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const CardContainerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  height: 160px;
  /* border: 1px solid red; */
`;
